const copyContent = async (textId)=>{
    let copied = document.getElementById('copied-text');
    let text = document.getElementById(textId).innerHTML;
    try {
        await navigator.clipboard.writeText(text);
        copied.className = 'show';
        setTimeout(()=>{
            copied.className = copied.className.replace('show', '');
        }, 3000);
        console.log('Content copied to clipboard');
    } catch (err) {
        console.error('Failed to copy: ', err);
    }
};

//# sourceMappingURL=en-run.cc1001cc.js.map
